import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import {
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  Select,
} from '@material-ui/core';

import SaveButton from 'app/components/SaveButton';
import notification from 'app/config/notification';
import { FormattedMessage } from 'react-intl';
import companyEndpoints from 'app/api/services/companyEndpoints';

const CompanySelection = props => {
  const { classes, intl, handleSubmit, handleCancel } = props;
  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);

  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [companySelected, setCompanySelected] = useState(null);

  useEffect(() => {
    const init = async () => {
      if(internalNewRequest.companies){
        const tempCompanies = [];
        for (const c of internalNewRequest.companies) {
          let response = await companyEndpoints.getCompany({ cdEmpresa: c });
          if (response.status === 200 && response.data) {
            tempCompanies.push(response.data);
          }
        }
        setCompanies(tempCompanies);
        setLoading(false);
      }
    }
    init();
  }, [internalNewRequest.companies]);

  const handleChangeCompany = e => {
    const company = _.find(companies, ['cdEmpresa', Number(e.target.value)]);
    setCompanySelected(company);
  };

  return (
    <Grid container spacing={3} className={classes.containerForm}>

      {loading && (
        <Grid item xs={12} className={classes.centerProgress}>
          <CircularProgress size={18} />
        </Grid>
      )}

      {!loading && (
        <Grid item xs={12}>
          <div className={classes.container}>
            <Grid item xs={12} className={classes.boxTextField}>
              <FormControl variant="filled" margin="dense" fullWidth>
                <InputLabel htmlFor="empresa">
                  <FormattedMessage id="LABELS.COMMONS.COMPANY" />
                </InputLabel>
                <Select
                  name="empresa"
                  id="empresa"
                  native
                  onChange={e => handleChangeCompany(e)}
                >
                  <option aria-label="None" value="" />
                  {companies.map((company, index) => {
                    return (
                      <option key={index} value={company.cdEmpresa}>
                        {company.cdEmpresa} -{' '}
                        {company.nmCompleto ? company.nmCompleto : company.deRazaoSocial}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </div>
        </Grid>
      )}
      <SaveButton
        mainColor={'primary'}
        hideActionBtn={false}
        isInternalForm={true}
        canEdit={true}
        onCancel={() => {
          handleCancel(null, true);
        }}
        onSave={() => {
          if (companySelected) {
            handleSubmit('company', null, companySelected);
          } else {
            notification(
              intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.NO_COMPANY_USER_SELECTED' }),
              { toastId: 'NO_COMPANY_USER_SELECTED', type: 'warning' }
            );
          }
        }}
        cancelLabel={'Cancelar'}
        saveLabel={'Confirmar'}
      />
    </Grid>
  );
};

export default CompanySelection;
